import PropTypes from 'prop-types'
import React from 'react'
import { imagesCDN } from 'src/core/constants/imagesCDN'

export const Item = ({icon, iconSvg, value, unit, title}) => (
  <div className='oglasi-glavne-informacije-item'>
    {iconSvg
      ? <img src={`${imagesCDN}${iconSvg}`} />
      : <i className={icon} />}
    <p>{value} {unit}</p>
    <p>{title}</p>
  </div>
)

Item.propTypes = {
  icon: PropTypes.string,
  iconSvg: PropTypes.string,
  unit: PropTypes.any,
  value: PropTypes.string,
  title: PropTypes.string.isRequired
}
